export default "__VITE_ASSET__cvBxhJ5I__"